import { createContext } from 'react';
const FrameworkTableContext = /*#__PURE__*/createContext({
  setSidePanelId: () => {}
});
export default FrameworkTableContext;